/* eslint-disable indent */
import { Colors } from "../constants/colors";
import { FONTS } from "./styles";

const getEmFontSize = (size) => `${size}px`;

export const muiTabs = {
  styleOverrides: {
    indicator: ({ ownerState }) => ({
      ...(ownerState &&
        ownerState.orientation === "horizontal" && {
          width: "100%",
          height: 3,
          backgroundColor: "#fff",
          alignSelf: "flex-start",
          borderRadius: "3px 3px 0px 0px",
        }),
      ...((!ownerState || ownerState.orientation === "vertical") && {
        display: "none",
      }),
    }),
  },
  variants: [
    {
      props: { orientation: "page" },
      style: {
        "& .MuiTab-root": {
          fontSize: getEmFontSize(16),
          fontFamily: FONTS.REGULAR,
          lineHeight: getEmFontSize(18),
          color: Colors.GREY200,
          textTransform: "uppercase",
          "&.Mui-selected": {
            color: Colors.WHITE,
          },
        },
      },
    },
    {
      props: { orientation: "horizontal" },
      style: {
        "& .MuiTab-root": {
          fontSize: getEmFontSize(16),
          fontFamily: FONTS.REGULAR,
          lineHeight: getEmFontSize(18),
          color: Colors.GREY200,
          textTransform: "uppercase",
          "&.Mui-selected": {
            color: Colors.WHITE,
          },
        },
      },
    },
    {
      props: { orientation: "vertical" },
      style: {
        "& .MuiTab-root": {
          fontSize: getEmFontSize(16),
          fontFamily: FONTS.REGULAR,
          lineHeight: getEmFontSize(18),
          color: Colors.GREY200,
          minHeight: "60px",
          height: "60px",
          width: "100%",
          maxWidth: "none",
          textTransform: "none",
          alignItems: "flex-start",
          borderRadius: "4px",
          marginBottom: "20px",
          textAlign: "left",
          "&.Mui-selected": {
            background: "rgba(255, 255, 255, 0.2)",
            color: Colors.WHITE,
          },
          "& .tab-container": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            width: "100%",
          },
        },
        "&.Mui-focusVisible": {
          backgroundColor: "#d1eaff",
        },
      },
    },
  ],
};
